import script from "./StepsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsView.vue?vue&type=script&setup=true&lang=js"

import "./StepsView.vue?vue&type=style&index=0&id=a32fc664&lang=css"

const __exports__ = script;

export default __exports__